import { render, staticRenderFns } from "./menuDisplays.vue?vue&type=template&id=7283596f&scoped=true&"
import script from "./menuDisplays.vue?vue&type=script&lang=js&"
export * from "./menuDisplays.vue?vue&type=script&lang=js&"
import style0 from "./menuDisplays.vue?vue&type=style&index=0&id=7283596f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7283596f",
  null
  
)

export default component.exports